const unlayerConfig = {
  minHeight: '100vh',
  locale: 'en-US',
  tools: {
    image: {
      enabled: true,
    },
    social: {
      enabled: true
    }
  },
  options: {
    mergeTagsConfig: {
      autocompleteTriggerChar: '@',
    },
  },
  specialLinks: [
    {
      name: 'Unsubscribe',
      href: 'https://UNSUB_LINK_EN',
      target: '_blank',
    },
    {
      name: 'View In Browser',
      href: 'https://VIEW_IN_BROWSER_LINK',
      target: '_blank',
    },
  ],
}

export default ($vue) => {
  unlayerConfig.projectId = $vue.$configs.VUE_APP_UNLAYER_ID
  return unlayerConfig
}
